// extracted by mini-css-extract-plugin
export default {"moveBtn":"AdminMobileMoveBackBtn_moveBtn__auFjl"};